/** Status options for action plan items. */
export const STATUSES = [
  { value: "Não iniciado", short: "Não iniciado", className: "status-nao_iniciado",
    description: "Tarefa mapeada, ainda não entrou no cronograma." },
  { value: "Em andamento", short: "Em andamento", className: "status-em_andamento",
    description: "Atividade em execução pelo responsável." },
  { value: "Em espera",    short: "Em espera",    className: "status-em_espera",
    description: "Paralisada por dependência externa, recursos ou aprovação." },
  { value: "Concluída",    short: "Concluída",    className: "status-concluido",
    description: "Atividade finalizada e revisada." },
  { value: "Cancelada",    short: "Cancelada",    className: "status-cancelado",
    description: "Mudança de escopo/estratégia — não será mais executada." },
];

/** Map old "Pendente" → "Não iniciado" for backward compatibility. */
export function normalizeStatus(s) {
  if (!s) return "Não iniciado";
  if (s === "Pendente") return "Não iniciado";
  return s;
}

export function statusClass(status) {
  const s = normalizeStatus(status);
  return STATUSES.find((x) => x.value === s)?.className || "status-nao_iniciado";
}
